/** Possíveis status de um item da aplicação. Valores usados pela API. */
export const ITEM_STATUS = {
  processing: 'PROCESSING',
  processed: 'PROCESSED',
}

/** Possíveis resultados de uma aplicação. Valores usados pela API. */
export const APPLICATION_RESULT = {
    approved: 'APPROVED',
    reproved: 'REPROVED',
    waitingForReview: 'WAITING_FOR_REVIEW',
    waitingReview: 'WAITING_REVIEW',
}

/** Possíveis resultados de uma aplicação. Valores usados pela API. */
export const APPLICATION_RESULT_DESCRIPTION = {
  approved: 'Aprovado(a)',
  reproved: 'Reprovado(a)',
  waitingForReview: 'Análise requerida',
}
